import React, { Component } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Button } from "antd";
import PropTypes from "prop-types";
import fetchHandler from "../../../fetch/fetchHandler";
import monthPickerHoc from "../../../hoc/form/monthPickerHoc";
import { getFirmwareVersion } from "../../../fetch/fetchApi";

@monthPickerHoc
class getFrameWorkEdition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 10,
      interval: null,
    };
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
    this.interval = null;
    this.init();
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    fetchHandler(getFirmwareVersion, {
      stubId: this.props.stubId,
    }).then((res) => {
      // console.log(res);
    });
  }

  init() {
    this.interval = setInterval(() => {
      this.setState({
        count: this.state.count - 1,
      });
      console.log(this.state.count);

      if (this.state.count <= 0) {
        this.submitBtn();
      }
    }, 1000);
  }

  submitBtn() {
    clearInterval(this.interval);
    this.interval = null;
    this.props.endModal();
  }

  render() {
    return (
      <div>
        <div
          className="wenzi"
          style={{
            lineHeight: "20px",
            paddingBottom: "20px",
            fontSize: "14px",
          }}
        >
          设备固件版本获取中，请过{this.state.count}秒后刷新列表查看！
        </div>
        <Form className="login-form">
          <Form.Item style={{ textAlign: "center" }}>
            <Button
              type="primary"
              onClick={() => {
                console.log("end init");
                this.submitBtn();
              }}
            >
              我知道了
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export default getFrameWorkEdition;



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/getFrameWorkEdition.js